module.exports = __webpack_public_path__ + "img/collection-engagementRings050Carat.b43ccf5.webp";